<div class="row mt-5">
  <div class="col-9 flex">
    <div class="col-lg-1">
      <img class="patientImg" mat-card-image src="assets/img/patient.png" />
    </div>
    <div class="col-lg-11 name mt-1">
      <div class="col-md-12 name">
        {{ memberDetails.firstName }} {{ memberDetails.lastName }}
      </div>
      <div class="col-md-12 vitals">
        <span class="vital-item"> Age: {{ memberDetails.age }} </span>
        <span class="vital-separator"> • </span>
        <span class="vital-item" *ngIf="actualWeight != '[object Object]'">
          Weight: {{ actualWeight }} lb
        </span>
        <span class="vital-separator" *ngIf="actualWeight != '[object Object]'">
          •
        </span>
        <span class="vital-item">
          Height:
          {{
            memberDetails.height
              ? (memberDetails.height | number : "1.0-0")
              : "---"
          }}
          cm
        </span>
        <span class="vital-separator"> • </span>
        <span class="vital-item">
          <span
            *ngIf="
              bmiValue !== null && bmiValue !== undefined;
              else targetWeightLabel
            "
          >
            BMI: {{ bmiValue | number : "1.1-1" }}
          </span>
          <ng-template #targetWeightLabel>
            Target Weight:
            {{
              memberDetails.targetWeight
                ? (memberDetails.targetWeight | number : "1.0-0")
                : "---"
            }}
            lb
          </ng-template>
        </span>
      </div>
    </div>
  </div>
  <div class="col-3 text-right d-flex align-items-start justify-content-end">
    <button
      *ngIf="currentStep === 1"
      class="btnConfirm"
      style="
        border-radius: 50px;
        background-color: #75e6da;
        color: #05445e;
        border: none;
        padding: 10px 20px;
      "
      [disabled]="!isCurrentStepValid"
      (click)="onNextStep()"
    >
      Continue
    </button>

    <button
      *ngIf="currentStep === 2"
      class="btnConfirm"
      style="
        border-radius: 50px;
        background-color: #75e6da;
        color: #05445e;
        border: none;
        padding: 10px 20px;
      "
      (click)="onCreatePlan()"
    >
      {{ isEditMode ? "Update Exercise Plan" : "Create Fitness Plan" }}
    </button>
  </div>
</div>
